(ns manage.adset-decision-tree-page.tagging-and-trackers.meta-pixel.view
  (:require [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [manage.adset-decision-tree-page.tagging-and-trackers.meta-pixel.db :as db]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui tab-panel []
  (let [meta-pixel-value (use-subscribe [::db/meta-pixel])]
    ($ form-field
       {:label "Meta Pixel"}
       ($ input
          {:value meta-pixel-value
           :onChange (fn [^js event]
                       (rf/dispatch [::db/set-meta-pixel (-> event .-target .-value)]))}))))
